import {NgModule} from "@angular/core";
import {SharedModule} from "../shared/shared.module";
import {HelpChromeControlComponent} from "./help-chrome-control/help-chrome-control.component";

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        HelpChromeControlComponent
    ],
    exports: [
        HelpChromeControlComponent
    ]
})
export class HelpModule {

}
